/*
  src/redux/mixpanel/constants.js

  Created by Justin Chang on 5/22/2017.
*/

import { createConstant } from '../helpers';
const createConstantVariable = createConstant('mixpanel');

export const START_TIMER = createConstantVariable('START_TIMER');
export const ADD_TO_TOTAL_SESSION_DURATION = createConstantVariable('ADD_TO_TOTAL_SESSION_DURATION');



// WEBPACK FOOTER //
// ./src/redux/mixpanel/constants.js